export default "__VITE_ASSET__D5auGx1I__$_?nuxt_component=async&nuxt_component_name=IconFunctionIconsVerdeckterReissverschluss&nuxt_component_export=default__"